export const REWRITE_VERB_FORMS = [
  "rewrite",
  "rewrites",
  "rewritten",
  "rephrase",
  "rephrased",
  "reword",
  "rewords",
  "reworded",
  "rewording",
] as const;

export const REWRITE_VARIANT_NOUN_FORMS = [
  "alternative",
  "alternatives",
  "variant",
  "variants",
  "version",
  "versions",
  "take",
  "takes",
  "option",
  "options",
  "draft",
  "drafts",
] as const;

export const REWRITE_SIGNAL_TERMS = [...REWRITE_VERB_FORMS, "alternative phrasing", "alternative", "alternatives", "variant", "variants"] as const;

export const REWRITE_OPTION_LABEL_FORMS = ["option", "version", "variant", "alternative", "alt", "take", "draft"] as const;

function escapeRegexFragment(fragment: string): string {
  return fragment.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}

export function buildWordBoundaryRegex(words: readonly string[], flags = "i"): RegExp {
  const alternation = words.map((word) => escapeRegexFragment(word)).join("|");
  return new RegExp(`\\b(?:${alternation})\\b`, flags);
}

export const REWRITE_OPTION_LABEL_ALTERNATION = REWRITE_OPTION_LABEL_FORMS.map((label) => escapeRegexFragment(label)).join("|");
